import {useEffect, useState} from "react";

import {getProductPriceListByGroup} from "../api/product-price-list-by-group";

function useProductPriceList(productGroupId, productDetails, showSpecials = false) {
    const [productPriceList, setProductPriceList] = useState({});
    const [loadingPriceList, setLoadingPriceList] = useState(false);

    let productIdAndUnitList = [];
    if (productDetails?.data_table) {
        productIdAndUnitList = productDetails.data_table['body'].map((item) => {
            return {
                productCode: item.product_code,
                unitCode: item.unit_code,
            };
        });
    }
    productIdAndUnitList = productIdAndUnitList.filter(item => item.productCode && item.unitCode);

    const loadProductPriceList = async (productIdAndUnitList) => {
        setLoadingPriceList(true);
        const priceList = await getProductPriceListByGroup(productIdAndUnitList);
        setLoadingPriceList(false);

        /*
        // TODO use this spread when improve endpoint to work with list Data productCode and unitCode
        // step 1
        const [productPriceList, setProductPriceList] = useState({});
        // step 2
        setProductPriceList((prevPriceList) => {
            return {...prevPriceList, ...priceList}
        });
        */
        setProductPriceList(priceList);
    };

    useEffect(() => {
        let ignore = false;
        if (showSpecials && !ignore && Array.isArray(productIdAndUnitList) && productIdAndUnitList.length) {
            loadProductPriceList(productIdAndUnitList);
        }

        return () => {
            ignore = true;
        }
    }, [productGroupId, productDetails]);

    return {
        productPriceList,
        loadingPriceList,
    };
}

export default useProductPriceList;